import React, { Component } from 'react';
import { bool, object, string, func } from 'prop-types';
import { API, Storage, graphqlOperation } from 'aws-amplify';
import get from 'lodash/get';

import MediaService from './media';
import {
  SCDropZone,
  Text,
  TextContainer,
  DownloadContainer,
  Plus,
  File,
  FileUpload,
  FileUploadLarge,
  DocumentName,
  CloseCircle,
  SpinnerOverlay,
} from './styles';
import { Button } from '../Buttons';
import Spinner from '../Spinner';
import fileImage from '../../assets/svg/document.svg';
import plusSignWhite from '../../assets/svg/plus-sign-white.svg';
import plusSignGrey from '../../assets/svg/plus-sign-grey.svg';
import downloadSvg from '../../assets/svg/download.svg';
import closeCircle from '../../assets/svg/close-circle.svg';
import documentHover from '../../assets/svg/document-hover.svg';
import removeDocument from './queries';
import { apiCall } from '../../services/initiation';

class FileUploader extends Component {
  static propTypes = {
    uploaded: bool,
    document: object, // eslint-disable-line react/forbid-prop-types
    fileType: string.isRequired,
    applicantId: string.isRequired,
    getDocuments: func.isRequired,
    identityId: string.isRequired,
    getCase: func.isRequired,
    noDocuments: bool,
  };
  static defaultProps = {
    uploaded: false,
    noDocuments: false,
    document: {},
  };

  state = {
    status: 1,
  };

  getTitle = () => {
    switch (this.props.fileType) {
      case 'MIN_UC':
        return 'min uc';
      case 'ID_PROOF':
        return 'personbevis';
      case 'INCOME_BASE':
        return 'intyg på inkomst';
      case 'RENTAL_AGREEMENT':
        return 'hyresavtal';
      case 'RENTAL_BASE':
        return 'intyg på hyra';
      default:
        return 'dokument';
    }
  };

  uploadFileDrop = (file) => {
    fetch(file.preview)
      .then((response) => response.blob())
      .then(() => {
        const ms = new MediaService(Storage, API, graphqlOperation);

        // applicantId, file, folder, type
        ms.storePrivateFile(
          this.props.applicantId,
          file,
          this.props.identityId,
          this.props.fileType
        )
          .then(() => {
            this.props.getDocuments();
            this.props.getCase();
            this.setState({ status: 1 });
          })
          .catch((err) => {
            window.debug.log(err);
          });
      })
      .catch((err) => {
        window.debug.log(err);
      });
  };

  replaceFileDrop = (file) => {
    fetch(file.preview)
      .then((response) => response.blob())
      .then(() => {
        const ms = new MediaService(Storage, API, graphqlOperation);
        ms.replacePrivateFile(
          this.props.document.id,
          this.props.applicantId,
          file
        )
          .then(() => {
            this.props.getDocuments();
            this.props.getCase();
            this.setState({ status: 1 });
          })
          .catch((err) => {
            window.debug.log(err);
          });
      })
      .catch((err) => {
        window.debug.log('Error:', err);
      });
  };

  handleFileDrop = (files) => {
    this.setState({ status: 2 });
    if (!(files instanceof Array)) return null;
    if (this.props.uploaded) {
      this.replaceFileDrop(files[0]);
    } else {
      files.forEach((file) => {
        this.uploadFileDrop(file);
      });
    }
    return true;
  };

  removeDocument = () => {
    this.setState({ status: 2 });
    apiCall(graphqlOperation(removeDocument(this.props.document.id))).then(
      () => {
        this.props.getDocuments();
        this.props.getCase();
      }
    );
  };

  downloadDocument = (fileName) => {
    const ms = new MediaService(Storage, API, graphqlOperation);
    ms.getPrivateFile(fileName).then((resp) => window.open(resp));
  };

  cutString = (fileName) => {
    const decodedFileName = decodeURIComponent(fileName);
    let cutFileName = decodedFileName;
    if (decodedFileName !== undefined && decodedFileName.indexOf('&#') > -1) {
      cutFileName = decodedFileName.substring(
        0,
        decodedFileName.indexOf('&#timestamp')
      );
    }
    return cutFileName;
  };

  render() {
    if (this.props.noDocuments) {
      return (
        <FileUploadLarge
          status={this.state.status}
          onDrop={this.handleFileDrop}
          rejected={
            get(this, 'props.document.approvalStatus.type') === 'REJECTED'
              ? 1
              : 0
          }>
          <SCDropZone
            onDrop={this.handleFileDrop}
            accept="image/jpeg,image/gif,image/png,application/pdf,image/heic">
            {this.state.status === 1 && (
              <React.Fragment>
                <Button big primary>
                  Ladda upp {this.getTitle()}
                </Button>
                <p>Eller dra in det här</p>
              </React.Fragment>
            )}
          </SCDropZone>
          {this.state.status === 2 && (
            <SpinnerOverlay>
              <Spinner />
            </SpinnerOverlay>
          )}
        </FileUploadLarge>
      );
    }

    return this.props.uploaded ? (
      <File
        svg={fileImage}
        isUploading={this.state.status === 2}
        svghover={documentHover}
        plussignwhite={downloadSvg}
        onDrop={this.handleFileDrop}
        uploaded={this.props.uploaded}
        rejected={
          get(this, 'props.document.approvalStatus.type') === 'REJECTED' ? 1 : 0
        }>
        {this.props.uploaded && (
          <CloseCircle
            svg={closeCircle}
            onClick={() => this.removeDocument()}
          />
        )}
        {this.state.status !== 2 && this.props.uploaded && (
          <DownloadContainer
            onClick={() => this.downloadDocument(this.props.document.fileName)}>
            <Plus svg={downloadSvg} />
            <Text>Öppna</Text>
          </DownloadContainer>
        )}
        <SCDropZone
          onDrop={this.handleFileDrop}
          plussignwhite={plusSignWhite}
          accept="image/jpeg,image/gif,image/png,application/pdf,image/heic">
          {this.state.status !== 2 && (
            <TextContainer>
              <Plus svg={plusSignWhite} />
              <Text>Ändra</Text>
            </TextContainer>
          )}
        </SCDropZone>
        {this.state.status === 2 && (
          <SpinnerOverlay small>
            <Spinner />
          </SpinnerOverlay>
        )}
        <DocumentName status={this.state.status} small>
          {this.props.document && this.cutString(this.props.document.fileName)}
        </DocumentName>
      </File>
    ) : (
      <FileUpload
        status={this.state.status}
        onDrop={this.handleFileDrop}
        rejected={
          get(this, 'props.document.approvalStatus.type') === 'REJECTED' ? 1 : 0
        }>
        <SCDropZone
          onDrop={this.handleFileDrop}
          accept="image/jpeg,image/gif,image/png,application/pdf,image/heic">
          <TextContainer>
            <Plus svg={plusSignGrey} />
            <Text>Lägg upp fler</Text>
          </TextContainer>
        </SCDropZone>
        {this.state.status === 2 && (
          <SpinnerOverlay small>
            <Spinner />
          </SpinnerOverlay>
        )}
      </FileUpload>
    );
  }
}

export default FileUploader;



// WEBPACK FOOTER //
// ./src/components/FileUploader/FileUploader.js